import React, { useEffect, useState } from "react";
import { Col, Row, Form, Checkbox } from "antd";
import {CustomInput,CustomParagraph} from "../../../components";
import { useSpin } from "../../../components/SpinContext";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";
const CreateAccount = () => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();

  // useEffect(() => {
  //   const isAuthenticated = localStorage.getItem("@token");
  //   if (isAuthenticated) {
  //     navigate("/dashboard");
  //   }
  // }, [navigate]);

  const onFinish = async (values) => {
    if (values && Object.keys(values).length > 0) {
      setIsFormValid(true);
      // showSpin();
      console.log("values : ", values);
      // try {
      //   const res = await OnboardingCreateAccount(values);
      //   console.log("res", res);
      //   if (res?.data?.is_success) {

      //   } else {
      //     message.error(res?.data?.message);
      //   }
      // } catch (error) {
      //   console.error("Login Error:", error);
      // } finally {
      //   hideSpin();
      //   setIsFormValid(false);
      // }
    }
  };

  return (
    <div className="wrapper-create-account">
      <Form
        layout="vertical"
        form={form}
        name="validateOnly"
        onFinish={onFinish}
      >
        <CustomParagraph
          text={"Create your account"}
          fontSize="28px"
          fontWeight="700"
          lineHeight="40px"
          marginBottom="32px"
        />
        <Row gutter={[16, 24]}>
          {/* name  */}
          <Col span={24}>
            <Form.Item
              className="custom-input"
              label="Your name"
              name="name"
              rules={[
                { required: true, message: "Please enter your name" },
                { type: "text", message: "Please enter a valid name" },
              ]}
            >
              <CustomInput
                placeholder="First and last"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>

          {/* title */}
          <Col span={24}>
            <Form.Item
              className="custom-input"
              label="Your title"
              name="title"
              rules={[
                { required: true, message: "Please enter title" },
                { type: "text", message: "Please enter a valid title" },
              ]}
            >
              <CustomInput
                placeholder="e.g. Logistics Coordinator"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>

          {/* password  */}
          <Col span={24}>
            <Form.Item
              className="custom-input"
              label="Create a password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
                { type: "password", message: "Please enter a valid password" },
                {
                  type: "string",
                  min: 6,
                  message: "Password must be at least 6 characters long.",
                },
                {
                  type: "string",
                  max: 20,
                  message: "Password cannot exceed 20 characters.",
                },
              ]}
            >
              <CustomInput
                placeholder=""
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
                type="password"
              />
            </Form.Item>
          </Col>

          {/* phone number  */}
          <Col span={24}>
            <div className="my-2">
              <Form.Item
                label={"Phone number (optional)"}
                name="phone_number"
                style={{ marginBottom: "0px" }}
                initialValue=""
               rules={[
                                {
                                  validator: (_, value) => {
                                    if (!value || value.trim() === '') {
                                      return Promise.resolve(); // Optional
                                    }
                                    try {
                                      if (isValidPhoneNumber(value)) {
                                        return Promise.resolve();
                                      } else {
                                        return Promise.reject(new Error("Invalid phone number"));
                                      }
                                    } catch {
                                      return Promise.reject(new Error("Invalid phone number"));
                                    }
                                  },
                                },
                              ]}
                
              >
                <PhoneInput
                  country={"us"}
                  value={form.getFieldValue("phone_number")}
                  onChange={(value, countryData, e, formattedValue) => {
                    form.setFieldsValue({ phone_number: formattedValue });
                  }}
                />
              </Form.Item>
            </div>
          </Col>

          {/* notifications medium  */}
          <Col span={24}>
            <Form.Item
              label="Opt in for notifications via..."
              name="notifications"
            >
              <Checkbox.Group
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <Checkbox value="sms">SMS</Checkbox>
                <Checkbox value="whatsapp">WhatsApp</Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CreateAccount;
